export const MAIL_TEMPLATES = {
    contactUs: "pawsall_contact_us_form",
    petSittingRequest: "pawsall_pet_sitting_request_form",
} as const

export type MailTemplateName =
    (typeof MAIL_TEMPLATES)[keyof typeof MAIL_TEMPLATES]

export interface BaseMailFormModel {
    to: string
    email: string
}
